import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

function PopularSection() {
  const popular = [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);
  return (
    <section className="bg-background-100 py-12 md:py-16" aria-labelledby="popular-title">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex items-end justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-accent-700">人气推荐</span>
            <h2 id="popular-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              本周人气漫画
            </h2>
            <p className="mt-2 text-sm text-foreground-600">高人气分类直接推荐，大家都在看的漫画</p>
          </div>
          <Link to="/category" className="hidden whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex">
            更多推荐 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5">
          {popular.map((item) => (
            <MangaCard key={item.slug} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default PopularSection;